import { useCallback } from 'react';
import { useRouter } from 'next/router';

export function useScrollIntoViewElementId() {
  const router = useRouter();

  const scrollIntoView = useCallback(
    (elementId: string, updatePath: boolean = false) => {
      const element = document.getElementById(elementId);
      if (!element) return;

      if (updatePath) {
        router.push(`#${elementId}`, undefined, { scroll: false, shallow: true });
      }
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    },
    [router]
  );

  return { scrollIntoView };
}
